module.exports = "<div class=\"<%= wrap %>\">\r\n    <div class=\"<%= textStyle %>\" ng-bind-html=\"match.model.classification | gwTypeaheadHighlight:query\"></div>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./common/grunt/webpack/loaders/text-loader!./common/js/src/edge/platform/widgets/typeahead/matchContentDirectives/IndustryCode/IndustryCode.html
// module id = 609
// module chunks = 0